/**
 * EmailPreviewContent Component
 * Styled component for displaying email HTML preview content
 * Properly handles dangerouslySetInnerHTML with responsive styling
 */

import React from "react";
import styled from "styled-components";

const PreviewContainer = styled.div`
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  width: 100%;
  max-width: 100%;
  
  /* Prevent content overflow */
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  /* Responsive font size */
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 1.5;
  }
  
  /* Ensure images scale properly */
  img {
    max-width: 100%;
    height: auto;
  }
  
  /* Prevent table overflow */
  table {
    max-width: 100%;
    table-layout: fixed;
  }
`;

/**
 * EmailPreviewContent Component
 * @param {Object} props
 * @param {string} props.html - HTML content to render
 * @param {string} [props.className] - Additional CSS classes
 */
const EmailPreviewContent = ({ html, className, ...props }) => {
  return (
    <PreviewContainer
      dangerouslySetInnerHTML={{ __html: html || "<p>Loading preview...</p>" }}
      className={className}
      {...props}
    />
  );
};

export default EmailPreviewContent;

